// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const TenantRole = {
  Administrator: "administrator",
  Member: "member",
  Guest: "guest",
} as const;
export type TenantRole = (typeof TenantRole)[keyof typeof TenantRole];

export function instanceOfTenantRole(value: any): boolean {
  for (const key in TenantRole) {
    if (Object.prototype.hasOwnProperty.call(TenantRole, key)) {
      if (TenantRole[key as keyof typeof TenantRole] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TenantRoleFromJSON(json: any): TenantRole {
  return TenantRoleFromJSONTyped(json, false);
}

export function TenantRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantRole {
  return json as TenantRole;
}

export function TenantRoleToJSON(value?: TenantRole | null): any {
  return value as any;
}

export function TenantRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): TenantRole {
  return value as TenantRole;
}
